import { HelpLink } from 'elements/link/HelpLink'
import { useTranslate } from 'react-admin'

const WorkflowsTitle = ({ record, style }) => {
  const translate = useTranslate()
  return (
    <span style={style}>
      {translate('Project Workflows')}: {record ? `"${record.title}"` : ''}
    </span>
  )
}

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate(
        "Ensure your team is staying on track with their projects by using Project Workflows to customise project stages and actions to match your business' needs."
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/13277670208271-How-to-customize-project-workflows-stages-and-actions" />
    </span>
  )
}

export default {
  list: { lazy: () => import('./Workflows'), component: 'WorkflowList' },
  edit: { lazy: () => import('./Workflows'), component: 'WorkflowEdit' },
  create: { lazy: () => import('./Workflows'), component: 'WorkflowCreate' },
  options: {
    create: {
      title: 'Create Workflow',
      subtitle: null,
      breadCrumb: 'Create Workflow',
    },
    list: {
      title: 'Project Workflows',
      subtitle: <Subtitle />,
      breadCrumb: 'Project Workflows',
    },
    edit: {
      title: <WorkflowsTitle />,
      subtitle: null,
      breadCrumb: 'Edit Workflow',
    },
  },
}
